export default __webpack_public_path__ + "static/standards-australia-logo-2ff33454dc9f2d20ea10f3cf4cfff38c.png";